export default "__VITE_ASSET__28b67f84__"